__turbopack_context__.v({
  "activityCharts": "ClubProfileAnalytics-module-scss-module__cwI-vq__activityCharts",
  "analytics": "ClubProfileAnalytics-module-scss-module__cwI-vq__analytics",
  "belowRow": "ClubProfileAnalytics-module-scss-module__cwI-vq__belowRow",
  "blockState": "ClubProfileAnalytics-module-scss-module__cwI-vq__blockState",
  "blockStateLarge": "ClubProfileAnalytics-module-scss-module__cwI-vq__blockStateLarge",
  "blockStateText": "ClubProfileAnalytics-module-scss-module__cwI-vq__blockStateText",
  "blockStateTitle": "ClubProfileAnalytics-module-scss-module__cwI-vq__blockStateTitle",
  "chartSkeleton": "ClubProfileAnalytics-module-scss-module__cwI-vq__chartSkeleton",
  "growthChart": "ClubProfileAnalytics-module-scss-module__cwI-vq__growthChart",
  "growthLocationCard": "ClubProfileAnalytics-module-scss-module__cwI-vq__growthLocationCard",
  "growthLocationContent": "ClubProfileAnalytics-module-scss-module__cwI-vq__growthLocationContent",
  "growthPart": "ClubProfileAnalytics-module-scss-module__cwI-vq__growthPart",
  "leftColumn": "ClubProfileAnalytics-module-scss-module__cwI-vq__leftColumn",
  "leftSkeleton": "ClubProfileAnalytics-module-scss-module__cwI-vq__leftSkeleton",
  "leftStubCard": "ClubProfileAnalytics-module-scss-module__cwI-vq__leftStubCard",
  "locationCharts": "ClubProfileAnalytics-module-scss-module__cwI-vq__locationCharts",
  "locationFlagImage": "ClubProfileAnalytics-module-scss-module__cwI-vq__locationFlagImage",
  "locationPart": "ClubProfileAnalytics-module-scss-module__cwI-vq__locationPart",
  "miniChartBar": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniChartBar",
  "miniChartCount": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniChartCount",
  "miniChartFill": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniChartFill",
  "miniChartFillActive": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniChartFillActive",
  "miniChartLabel": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniChartLabel",
  "miniChartPercent": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniChartPercent",
  "miniChartRow": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniChartRow",
  "miniChartSlash": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniChartSlash",
  "miniChartValue": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniChartValue",
  "miniChartValueActive": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniChartValueActive",
  "miniCharts": "ClubProfileAnalytics-module-scss-module__cwI-vq__miniCharts",
  "rangeText": "ClubProfileAnalytics-module-scss-module__cwI-vq__rangeText",
  "retry": "ClubProfileAnalytics-module-scss-module__cwI-vq__retry",
  "row": "ClubProfileAnalytics-module-scss-module__cwI-vq__row",
});
